shadow$provide[2166] = function(require,module,exports) {
module.exports=(jspdf);
};